import { Button, Result } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from '@redux';

export default function NotFound() {
  const navigate =useNavigate();
  const token = useSelector(state=>state.auth.token);
  const goLogin = ()=>{
    navigate('/login');
  };

  const goHome = ()=>{
    navigate('/');
  }
  return (
    <Result 
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={!token?<Button onClick={goLogin} type="primary">Back Login</Button>:<Button onClick={goHome} type="primary">Back Home</Button>}
    />
  )
}
